export * as Campaign from './index.pc'
export * as MobileCampaign from './index.mobile'
